/*
 * Module for the Service Purhase Payment Detail view
*/

rs.module("content/participant/member/servicepurchase/paymentdetail",

    ["common/select-helper", "common/visibility" ],

    function (selectHelper, visibility) {

        //
        // Initialize
        //
        function initialize(jsSelectors, codeValues) {
            var form = $.js(jsSelectors.form);
            var paymentMethod = form.js(jsSelectors.paymentMethod);
            var paymentAmount = form.js(jsSelectors.paymentAmount);
            var checkNumber = form.js(jsSelectors.checkNumber);
            var downPayment = form.js(jsSelectors.downPayment);
            var principalOnly = form.js(jsSelectors.principalOnly);
            var principalOnlyHiddenInput = form.js(jsSelectors.principalOnlyHiddenInput);
            var preTaxPaymentsFlag = form.js(jsSelectors.preTaxPaymentsFlag);
            var preTaxPaymentsFlagHiddenInput = form.js(jsSelectors.preTaxPaymentsFlagHiddenInput);            
            var rolloverCard = form.js(jsSelectors.rolloverCard);
            var rolloverType = form.js(jsSelectors.rolloverType);
            var rolloverTypeSelectHelper = selectHelper.getHelper(rolloverType);
            var batchNumberLabel = form.js(jsSelectors.batchNumberLabel);

            paymentMethod.on("change", function () {
                var isErsTransmittal = paymentMethod.val() == codeValues.ersTransmittal;
                if (isErsTransmittal) {
                    checkNumber.val(null);
                }
                checkNumber.prop("disabled", isErsTransmittal);
                visibility.setVisible(batchNumberLabel, isErsTransmittal);

                var isRolloverMethod = paymentMethod.val() == codeValues.rollover;
                paymentAmount.prop('disabled', isRolloverMethod);
                preTaxPaymentsFlag.prop('disabled', isRolloverMethod);
                preTaxPaymentsFlagHiddenInput.prop('disabled', !isRolloverMethod);
                if (isRolloverMethod) {
                    paymentAmount.val(null);
                    preTaxPaymentsFlag.setChecked(false);
                    preTaxPaymentsFlagHiddenInput.val(false);
                }
                rolloverCard.find(":input").each(function () {
                    $(this).prop('disabled', !isRolloverMethod);
                });
                rolloverTypeSelectHelper.setDisabled(!isRolloverMethod);
            });

            downPayment.on("change", function () {
                var downPaymentOnlyChecked = downPayment.is(":checked");
                principalOnly.setChecked(downPaymentOnlyChecked);
                principalOnly.prop("disabled", downPaymentOnlyChecked);
                principalOnlyHiddenInput.prop("disable", !downPaymentOnlyChecked);
                principalOnlyHiddenInput.val(downPaymentOnlyChecked);
            });

            if (downPayment.is(":checked")) {
                var downPaymentOnlyChecked = downPayment.is(":checked");
                principalOnly.setChecked(downPaymentOnlyChecked);
                principalOnly.prop("disabled", downPaymentOnlyChecked);
                principalOnlyHiddenInput.prop("disable", !downPaymentOnlyChecked);
                principalOnlyHiddenInput.val(downPaymentOnlyChecked);
            }

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);